import _cloneDeep from 'lodash/cloneDeep';

export default {
  merchantDetails: (state) => _cloneDeep(state.merchantDetails),
  merchantResults: (state) => _cloneDeep(state.merchantResults),
  commissionCharges: (state) => _cloneDeep(state.commissionCharges),
};
